import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { CgGitFork } from "react-icons/cg";
import { AiFillStar } from "react-icons/ai";
import logo from "../../Assets/logo.png";
import { repoUrl } from "../../data/content";

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/work", label: "Work" },
  { to: "/writing", label: "Writing" },
  { to: "/resume", label: "Résumé" },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Collapse the mobile menu whenever the route changes.
  useEffect(() => setOpen(false), [pathname]);

  const className = [
    "nav",
    scrolled ? "nav--scrolled" : "",
    open ? "nav--open" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <header className={className}>
      <div className="container nav__inner">
        <Link to="/" className="nav__brand">
          <img src={logo} className="nav__mark" alt="" />
          Dharmik Batra
        </Link>

        <button
          type="button"
          className="nav__toggle"
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
        >
          <span className="nav__toggle-bars" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </button>

        <div className="nav__menu">
          <nav aria-label="Main">
            <ul className="nav__links">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <NavLink
                    to={link.to}
                    end={link.to === "/"}
                    className={({ isActive }) =>
                      isActive ? "nav__link is-active" : "nav__link"
                    }
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>

          <div className="nav__actions">
            <a
              href={repoUrl}
              target="_blank"
              rel="noreferrer"
              className="nav__icon-btn"
              aria-label="Fork or star this portfolio on GitHub"
            >
              <CgGitFork />
              <AiFillStar />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
